


































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

// Model
import NotificationSettingsModel from '@/_models/NotificationSettings'
import GeofenceModel from '@/_models/GeofenceModel'

import { NOTIFICATION_TYPE } from '@/_consts/NotificationType'

// Shared
import FilterDropdown from '@/components/shared/FilterDropdown.vue'

@Component({
  components: {
    FilterDropdown,
  },
  computed: {},
})
export default class NotificationSettingsModal extends Vue {
  @Prop()
  dataProp!: NotificationSettingsModel

  data: NotificationSettingsModel = new NotificationSettingsModel()

  notificationType = NOTIFICATION_TYPE

  get geofences(): GeofenceModel[] {
    return this.$store.state.geofences.all.items
  }

  get errorsObject() {
    return this.errors?.items?.reduce(
      (obj, item) => ({
        ...obj,
        [item.field]: item.rule,
      }),
      {}
    )
  }

  get recipientsIsRequired() {
    return (
      this.errorsObject[`recipients`] &&
      this.errorsObject[`recipients`] === 'required'
    )
  }

  get recipientsIsValidEmail() {
    return (
      this.errorsObject[`recipients`] &&
      this.errorsObject[`recipients`] === 'email'
    )
  }

  get actionData() {
    return NOTIFICATION_TYPE.reduce((result, item) => {
      result[item.name] = item.actions || []
      return result
    }, {})
  }

  get buttonSaveText(): any {
    return this.data._id ? this.$t('button.save') : this.$t('button.register')
  }

  async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }
      if (!this.data._id) {
        // add item
        this.$store
          .dispatch('notification_settings/addOne', this.data)
          .then(() => {
            this.$emit('isFormModalActive', false)
            this.$buefy.toast.open(this.$t('messages.save_success') as string)
          })
      } else {
        // update item
        this.$store
          .dispatch('notification_settings/updateOne', this.data)
          .then(() => {
            this.$emit('isFormModalActive', false)
            this.$buefy.toast.open(this.$t('messages.update_success') as string)
          })
      }
    })
  }

  created() {
    if (this.dataProp) {
      this.data = JSON.parse(JSON.stringify(this.dataProp))
    }
  }
}
